module.exports = __webpack_public_path__ + "static/media/Vanderbilt_University.249d47f3.png";